import { NavLink } from 'react-router-dom';
import type { Env, Section } from '../types';

const ENVS: Env[] = ['test', 'dev', 'uat', 'prod'];

interface Props {
  section: Section;
}

export default function SectionEnvNav({ section }: Props) {
  return (
    <nav className="section-envnav" aria-label={`${section} environments`}>
      <div className="section-envnav-inner">
        {ENVS.map((e) => (
          <NavLink
            key={e}
            to={`/${section}/${e}`}
            className={({ isActive }) => (isActive ? 'active' : undefined)}
          >
            {e.toUpperCase()}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
